import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Container, Navbar, Nav, NavDropdown, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../actions/userActions";
import { toggleTheme } from "../actions/themeActions";
import SearchBox from "./SearchBox";
import { useNavigate } from "react-router-dom";
//call action = useDispatch
//bring something from state = useSelector

const Header = () => {
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const themeMode = useSelector((s) => s.theme?.mode || "light");
  const isDark = themeMode === "dark";
  const navigate = useNavigate();
  const logoutHandler = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <header>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600&family=Jost:wght@200;300;400;500&display=swap');

        /* ─── HADACY navbar — cream surface, gold accents, serif brand ─── */
        .hadacy-header {
          --cream: #f5f0e8;
          --dark: #1a1410;
          --gold: #b8933a;
          --gold-light: #d4af6a;
          --muted: #7a6e62;
          --card-bg: #faf7f2;

          background: var(--cream) !important;
          border-bottom: 1px solid rgba(184,147,58,0.18);
          padding: 1.35rem 0;
          font-family: "Jost", sans-serif;
        }

        @media (min-width: 992px) {
          .hadacy-header .container,
          .hadacy-header .navbar-collapse,
          .hadacy-header .navbar-nav {
            align-items: center;
          }
        }

        @media (max-width: 575.98px) {
          .hadacy-header {
            padding: 1rem 0;
          }
        }

        /* HADACY brand — serif, refined letter-spacing */
        .hadacy-header .navbar-brand {
          font-family: "Cormorant Garamond", serif !important;
          font-weight: 400;
          letter-spacing: 0.22em;
          font-size: 1.55rem;
          color: var(--dark) !important;
          line-height: 1;
          margin: 0;
          padding: 0.1rem 0 0;
        }

        /* Nav links — uppercase tracked sans-serif, gold on hover */
        .hadacy-header .nav-link {
          display: inline-flex;
          align-items: center;
          min-height: 40px;
          font-family: "Jost", sans-serif;
          font-weight: 400;
          font-size: 0.78rem;
          line-height: 1;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--dark) !important;
          transition: color .2s ease;
          padding: 0.5rem 0.85rem !important;
        }
        .hadacy-header .nav-link:hover,
        .hadacy-header .nav-link:focus { color: var(--gold) !important; }
        .hadacy-header .navbar-brand:hover { color: var(--gold) !important; }

        /* Dropdowns (Cesar / Admin) — cream card with soft shadow */
        .hadacy-header .dropdown-menu {
          background: var(--card-bg);
          border: 1px solid rgba(184,147,58,0.18);
          border-radius: 12px;
          box-shadow: 0 10px 25px rgba(26,20,16,0.08);
          padding: 0.4rem 0.25rem;
        }
        .hadacy-header .dropdown-menu .nav-link {
          color: var(--dark) !important;
          min-height: auto;
          padding: 0.4rem 0.85rem !important;
          border-radius: 8px;
          font-size: 0.74rem;
        }
        .hadacy-header .dropdown-menu .nav-link:hover {
          background: rgba(184,147,58,0.08);
          color: var(--gold) !important;
        }
        .hadacy-header .dropdown-toggle::after { color: var(--gold); }
        .hadacy-header .dropdown {
          display: inline-flex;
          align-items: center;
        }

        /* Mobile toggle */
        .hadacy-header .navbar-toggler {
          border-color: rgba(184,147,58,0.35);
        }
        .hadacy-header .navbar-toggler:focus {
          box-shadow: 0 0 0 3px rgba(184,147,58,0.2);
        }

        /* Cart icon — keep it dark, gold on hover */
        .hadacy-header .nav-link .fa-shopping-cart,
        .hadacy-header .nav-link .fa-user {
          line-height: 1;
          margin-right: 0.35rem;
        }

        /* ── SearchBox: pill-shaped, matches the inline home search ── */
        .hadacy-header form.form-inline {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          padding: 0.2rem 0.35rem 0.2rem 0.95rem;
          background: var(--card-bg);
          border: 1px solid rgba(184,147,58,0.3);
          border-radius: 999px;
          margin: 0.25rem 0;
          transition: border-color .2s ease, box-shadow .2s ease;
        }
        .hadacy-header form.form-inline:focus-within {
          border-color: var(--gold);
          box-shadow: 0 0 0 3px rgba(184,147,58,0.12);
        }
        .hadacy-header form.form-inline .form-control {
          flex: 1;
          min-width: 220px;
          border: none !important;
          background: transparent !important;
          outline: none !important;
          box-shadow: none !important;
          font-family: "Jost", sans-serif;
          font-size: 0.86rem;
          color: var(--dark);
          padding: 0.35rem 0.4rem !important;
          margin: 0 !important;
        }
        .hadacy-header form.form-inline .form-control::placeholder {
          color: var(--muted);
          font-style: italic;
        }
        .hadacy-header form.form-inline .btn {
          border: none !important;
          border-radius: 999px !important;
          padding: 0.45rem 1rem !important;
          background: var(--dark) !important;
          color: var(--gold-light) !important;
          font-family: "Jost", sans-serif;
          font-size: 0.66rem;
          font-weight: 400;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          margin: 0 !important;
          transition: background .2s ease, color .2s ease;
        }
        .hadacy-header form.form-inline .btn:hover {
          background: var(--gold) !important;
          color: var(--dark) !important;
        }
      `}</style>

      <Navbar
        className="hadacy-header"
        variant="light"
        expand="lg"
        collapseOnSelect
      >
        <Container>
          <Navbar.Brand as={Link} to="/">HADACY</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            {/* <div>
              <Routes>
                <Route path="/" element={<SearchBox></SearchBox>}></Route>
                <Route path="/search/*" element={<SearchBox></SearchBox>}></Route>
                <Route path="/page/*" element={<SearchBox></SearchBox>}></Route>
              </Routes>
            </div> */}
            <Nav className="ml-auto">
                          {/* Catálogo — oculto del menú por solicitud.
                              El código se conserva (no se elimina) y la ruta
                              /catalogo sigue existiendo en App.js.
              <Nav.Link as={Link} to="/catalogo">
              Catálogo
            </Nav.Link>
              */}
              <Nav.Link state={{ color: "black" }} as={Link} to="/cart">
                <i className="fas fa-shopping-cart"></i> Carrito
              </Nav.Link>
              {userInfo ? (
                <NavDropdown title={userInfo.name} id="username">
                  <Nav.Link as={Link} to="/profile" style={{ color: "black" }}>
                    {/* <i className="fas fa-user"></i> {userInfo.name} */}
                    Perfil
                  </Nav.Link>
                  <Nav.Link onClick={logoutHandler} style={{ color: "black" }}>
                    Logout
                  </Nav.Link>
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to="/login">
                  <i className="fas fa-user"></i> Iniciar Sesión
                </Nav.Link>
              )}

              {userInfo && userInfo.isAdmin && (
                <NavDropdown
                  title="Admin"
                  id="adminmenu"
                  style={{ color: "black" }}
                >
                  <Nav.Link
                    as={Link}
                    to="/admin/userlist"
                    style={{ color: "black" }}
                  >
                    Users
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/admin/productlist"
                    style={{ color: "black" }}
                  >
                    Products
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/admin/orderlist"
                    style={{ color: "black" }}
                  >
                    Orders
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/admin/visitors"
                    style={{ color: "black" }}
                  >
                    Visitors
                  </Nav.Link>
                  <Nav.Link as={Link} to="/admin/site-images" style={{ color: "black" }}>
                    Site Images
                  </Nav.Link>
                  <Nav.Link as={Link} to="/admin/documentos" style={{ color: "black" }}>
                    Documentos
                  </Nav.Link>
                  <Nav.Link as={Link} to="/admin/cupones" style={{ color: "black" }}>
                    Cupones
                  </Nav.Link>
                </NavDropdown>
              )}
              {/* Dark / light theme toggle — placed last so it reads as
                  a quiet utility action rather than a primary nav item.
                  Aria-label flips with the current state so screen
                  readers announce the *target* mode the click switches to. */}
              <button
                type="button"
                className="hadacy-theme-toggle"
                onClick={() => dispatch(toggleTheme())}
                aria-label={
                  isDark ? "Activar modo claro" : "Activar modo oscuro"
                }
                title={isDark ? "Modo claro" : "Modo oscuro"}
              >
                <i
                  className={isDark ? "fas fa-sun" : "fas fa-moon"}
                ></i>
              </button>
            </Nav>
          </Navbar.Collapse>
        </Container>
        <Row>
          <Col>
            <img
              className="img-fluid float-right ml-3"
              src={require("../img/Hada1_1.png")}
              style={{ width: "20px", height: "20px", borderRadius: "50%" }}
              alt="hero.jpg"
            />
          </Col>
        </Row>
      </Navbar>
    </header>
  );
};

export default Header;
